<template>
  <NotificationTypeWrapper :notification="notification">
    <p class="my-0">
      Payment account has
      <a
        :href="actionLink"
        v-text="'new requirements'"
      />
    </p>
  </NotificationTypeWrapper>
</template>

<script type="text/babel">
import NotificationTypeMixin from './NotificationTypeMixin'

export default {
  name: 'AccountHasNewRequirements',
  mixins: [NotificationTypeMixin],
  computed: {
    actionLink() {
      return this.$urlGenerator.active() + 'payments'
    },
  },
}
</script>
